export default "__VITE_ASSET__DYhYjFqe__"